import React, { Component } from 'react';
import PropTypes from 'prop-types';
import PopConfirm from '@omilia/popconfirm';

import InspectHeader from 'components/InspectHeader';
import InspectButton from 'components/InspectButton';
import { dictionaryType } from 'types';

class DictionaryInspectHeader extends Component {
  static propTypes = {
    dictionary: dictionaryType.isRequired,
    isExporting: PropTypes.bool,
    onDelete: PropTypes.func,
    onExport: PropTypes.func,
  };

  handleExport = () => {
    const { dictionary, onExport } = this.props;

    onExport(dictionary);
  };

  handleDelete = () => {
    this.props.onDelete(this.props.dictionary.id);
  };

  render() {
    const {
      dictionary: { archived },
      isExporting,
    } = this.props;

    return (
      <InspectHeader>
        <InspectButton
          isHeader
          data-test="export-dictionary"
          disabled={isExporting || archived}
          onClick={this.handleExport}
        >
          Export CSV
        </InspectButton>

        {!archived && (
          <PopConfirm
            confirmLabel="Yes"
            declineLabel="Cancel"
            placement="left"
            title="Are you sure you want to delete this dictionary?"
            onConfirm={this.handleDelete}
          >
            <InspectButton isHeader data-test="delete-dictionary">
              Delete Dictionary
            </InspectButton>
          </PopConfirm>
        )}
      </InspectHeader>
    );
  }
}

export default DictionaryInspectHeader;
